
import {HttpRequest,HttpMethod} from "./http";

class TiktokProvider extends HttpRequest {

    OrderList(params) {
        return this.request(HttpMethod.Get,`/api/platform/tiktok/orders`, params);
    }

    RefreshToken(params) {
        return this.request(HttpMethod.Get,`/api/platform/tiktok/refreshtoken`);
    }

    OrderShippingDocument(params) {
        return this.request(HttpMethod.Get,`/api/platform/tiktok/orders/document/shipping`, params);
    }

	// tiktok order package document
	OrderPackageDocument(params) {
		return this.request(HttpMethod.Get,`/api/platform/tiktok/orders/document/package`, params);
	}

	//Tiktok Get Product
	GetProduct(params) {
		return this.request(HttpMethod.Get,`/api/platform/tiktok/products`, params);
	}

	// Tiktok Sync Porduct
	SyncProduct(shopid , payload) {
		return this.request(HttpMethod.Post,`/api/platform/tiktok/products/sync?shop_id=${shopid}`, payload);
	}

	SyncOrder(shopid , payload) {
		return this.request(HttpMethod.Post,`/api/platform/tiktok/orders/sync?shop_id=${shopid}`, payload);
	}

	ConnectPlatform(params) {
		return this.request(HttpMethod.Post,`/api/platform/tiktok/connect`, params);
	}

}

export default TiktokProvider